module.exports = __webpack_public_path__ + "img/auth-promo-canvas.1455f05b.svg";